import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

const WithTooltip = (Component) => {
    const TooltipWrapper = (props) => {
        const {
            showTooltip, tooltipMessage, placement, trigger, ...restProps
        } = props;
        return showTooltip ? (
            <Tooltip
                placement={ placement }
                trigger={ trigger }
                overlay={ tooltipMessage }
                arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
            >
                <div className={ props.wrapperStyles.wrapper } href="#"><Component { ...restProps } /></div>
            </Tooltip>
        ) : <Component { ...restProps } />;
    };

    TooltipWrapper.propTypes = {
        showTooltip: PropTypes.bool,
        placement: PropTypes.string,
        tooltipMessage: PropTypes.string,
        trigger: PropTypes.arrayOf(PropTypes.string),
        wrapperStyles: PropTypes.objectOf(PropTypes.string)
    };

    TooltipWrapper.defaultProps = {
        showTooltip: false,
        placement: 'bottom',
        tooltipMessage: '',
        trigger: ['hover'],
        wrapperStyles: {}
    };
    return TooltipWrapper;
};

export default WithTooltip;
